import { Link } from "react-router-dom"
import "./header.css"
import { useEffect, useState } from "react"

export default function Header(){
    const [small, setSmall] = useState(false)
    const navSelect = () =>{
        window.innerWidth<768?setSmall(true):setSmall(false)
    }
    useEffect(() => {
        window.innerWidth<768?setSmall(true):setSmall(false)

        window.addEventListener('resize', navSelect);
        window.scrollTo(0, 0);
        return () => {
          window.scrollTo(0, 0);
          window.removeEventListener('resize', navSelect);
        };
      }, []);

    const [show, setShow] = useState(false)
    return(
        <nav className={small?"wrapper navBar navPosition":"wrapper navBar"}>
            <Link to={"/"}>
                <figure>
                    <img src="../images/logo.svg" alt="Sai Loans"/>
                    {/* <h3>Travelwise</h3> */}
                </figure>
            </Link>
            {small?(
                <>
                    <main className={show?"navMob showNav":"navMob hideNav"}>
                        <ul>
                            <li>
                                <Link 
                                    to={"/"}
                                    onClick={()=>setShow(!show)}
                                >
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to={"/about"}
                                    onClick={()=>setShow(!show)}
                                >
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to={"/destination"}
                                    onClick={()=>setShow(!show)}
                                >
                                    Destination
                                </Link>
                            </li>
                            {/* <li>
                                <Link 
                                    // to={"/associate"}
                                    onClick={()=>setShow(!show)}
                                >
                                    Associates
                                </Link>
                            </li> */}
                            <li>
                                <Link 
                                    to={"/contact"}
                                    onClick={()=>setShow(!show)}
                                >
                                    Contact
                                </Link>
                            </li>
                        </ul>
                        <figure className="menuDecor"> 
                            <img src="../images/flower_1.svg" alt="flower_!"/>
                        </figure>
                    </main>
                    <div className="nav_mob_menu_btn" onClick={()=>setShow(!show)}>
                        <div className={show?'bar right barMain':'bar barGold'} ></div>
                        <div className={show?'opaZero':'bar barGold'} style={{transition:'all 1s'}}></div>
                        <div className={show?'bar left barMain':'bar barGold'}></div>
                    </div>
                </>
            ):(
                <main className="navWeb">
                    <ul>
                        <li><Link to={"/"}>Home</Link></li>
                        <li><Link to={"/about"}>About</Link></li>
                        <li><Link to={"/destination"}>Destination</Link></li>
                        {/* <li><Link >Associates</Link></li> */}
                        <li><Link to={"/contact"}>Contact</Link></li>
                    </ul>
                </main>
            )}
            
        </nav>
    )
}